import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import AdminModal from 'components/admin2/ui/AdminModal';
import MediaLibrary from 'components/admin2/MediaLibrary';
import AjaxFetch from 'components/core/AjaxFetch';
import { camelify } from 'shared/string-utils';
import { ASC_KEY, DESC_KEY, NONE_KEY } from 'components/admin2/MediaLibrary/constants';
import { SERVICE_BASE_URL } from 'config';

// TODO remove this legacy this was dumb. shoulda stuck to my guns
const ENDPOINT_ROUTE = '/admin/v1';
const BASE_URL = SERVICE_BASE_URL;

const SORT_MAP = {
  [ASC_KEY]: 'asc',
  [DESC_KEY]: 'desc',
  [NONE_KEY]: null,
};

const SORT_MAP_ACCESSORS = {
  groupName: 'renderer.group_name',
  lastModified: 'last_modified',
  personName: 'renderer.person_name',
};

const StyledAdminModal = styled(AdminModal)`
  overflow: visible;
`;

const findInitialSort = columns => columns.find(col => Boolean(col.sort));

export default class LibraryModalQuickPick extends React.Component {
  static propTypes = {
    buttonProps: PropTypes.oneOfType([
      PropTypes.shape({
        labelKey: PropTypes.string,
        onClick: PropTypes.func,
      }),
      PropTypes.arrayOf(
        PropTypes.shape({
          labelKey: PropTypes.string,
          onClick: PropTypes.func,
        }),
      ),
    ]),
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    disableEditing: PropTypes.bool,
    fetchObject: PropTypes.shape({
      endpoint: PropTypes.string.isRequired,
      method: PropTypes.oneOf(['GET']),
    }).isRequired,
    forceRefresh: PropTypes.string,
    helperText: PropTypes.string,
    NewItemComponent: PropTypes.func,
    newItemLabel: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onEditItem: PropTypes.func,
    onSelectItem: PropTypes.func.isRequired,
    overrideUrl: PropTypes.string,
    primaryToken: PropTypes.string.isRequired,
    refreshKey: PropTypes.string.isRequired,
    searchPlaceholderKey: PropTypes.string,
    siteId: PropTypes.string.isRequired,
    titleKey: PropTypes.string.isRequired,
    transformRequestWithRenderer: PropTypes.bool,
  };

  static defaultProps = {
    buttonProps: [],
    disableEditing: false,
    forceRefresh: null,
    helperText: '',
    NewItemComponent: undefined,
    newItemLabel: '',
    onEditItem: null,
    overrideUrl: null,
    searchPlaceholderKey: '',
    transformRequestWithRenderer: false,
  };

  state = {
    loaded: false,
    modalOpen: false,
    params: {},
  };

  componentDidMount() {
  // eslint-disable-next-line react/destructuring-assignment
    this.handleSort(findInitialSort(this.props.columns));
  }

  handleResponse = (response) => {
    const { transformRequestWithRenderer, overrideUrl } = this.props;

    if (overrideUrl) { // shit - just for now
      this.setState({
        list: response.results,
        loaded: true,
      });
      return;
    }
    if (transformRequestWithRenderer) {
      this.setState({
        list: camelify(response.results).map(item => ({
          ...item.renderer,
          created: item.created,
          lastModified: item.lastModified,
        })).filter(item => item),
        loaded: true,
      });
    } else {
      this.setState({
        list: response.results,
        loaded: true,
      });
    }
  };

  handleSearch = (searchText) => {
    const searchParam = { search: searchText };
    this.setQueryParams(searchParam);
    this.setState({ loaded: false });
  };

  setQueryParams = (newParams) => {
    const { params: oldParams } = this.state;
    this.setState({
      params: {
        ...oldParams,
        ...newParams,
      },
    });
  };

  handleSort = (sortObject = {}) => {
    const { sort: sortKey, title: sortBy } = sortObject;
    const sortValue = SORT_MAP[sortKey];

    const sortParams = sortValue ? {
      sortBy: SORT_MAP_ACCESSORS[sortObject.accessor] || sortObject.accessor || sortBy,
      sortDirection: sortValue,
    } : {};

    this.setQueryParams(sortParams);
  };

  handleCreate = async () => {
    this.setState({ modalOpen: false });
  };

  handleModalOpen = () => {
    this.setState({ modalOpen: true });
  };

  handleItemModalClose = () => {
    this.setState({
      editingItemId: null,
      modalOpen: false,
    });
  };

  handleEditItem = (item) => {
    const { onEditItem } = this.props;
    if (onEditItem) {
      onEditItem(item);
      return;
    }
    const { id } = item;
    if (id) {
      this.setState({
        editingItemId: id,
      });
      this.handleModalOpen();
    }
  };

  render() {
    const {
      buttonProps,
      columns,
      fetchObject,
      forceRefresh, // used when updating refreshKey takes you out of the modal
      helperText,
      NewItemComponent,
      newItemLabel,
      onClose,
      onSelectItem,
      overrideUrl,
      primaryToken,
      refreshKey,
      searchPlaceholderKey,
      siteId,
      titleKey,
      disableEditing,
    } = this.props;
    const {
      modalOpen,
      list,
      loaded,
      params,
      editingItemId,
    } = this.state;

    const allowNewItem = newItemLabel && NewItemComponent;
    const actionButtons = allowNewItem ? {
      labelKey: newItemLabel,
      onClick: () => this.setState({ modalOpen: true }),
    } : buttonProps;

    const { endpoint, method } = fetchObject;
    const headers = {
      Authorization: `Bearer ${primaryToken}`,
      // Authorization: `Bearer ${PPP}`,
      'x-maestro-client-id': siteId,
    };

    return (
      <AdminModal
        onClose={onClose}
      >
        <AjaxFetch
          headers={headers}
          method={method}
          onValue={this.handleResponse}
          params={params}
          refreshKey={`${refreshKey}${forceRefresh}`}
          url={overrideUrl || `${BASE_URL}${ENDPOINT_ROUTE}${endpoint}`}
        />
        <MediaLibrary
          buttonProps={actionButtons}
          columns={columns}
          disableEditing={disableEditing}
          helperText={helperText}
          list={list}
          loaded={loaded}
          onEditItem={this.handleEditItem}
          onSearch={this.handleSearch}
          onSelectItem={onSelectItem}
          onSort={this.handleSort}
          searchPlaceholderKey={searchPlaceholderKey}
          setLoading={() => this.setState({ loaded: false })}
          titleKey={titleKey}
        />
        {
          modalOpen && (
          <StyledAdminModal
            onClose={this.handleItemModalClose}
          >
            { allowNewItem && (
            <NewItemComponent
              editingItemId={editingItemId}
              onClose={this.handleItemModalClose}
              onCreate={this.handleCreate}
            />
            ) }
          </StyledAdminModal>
          )
      }
      </AdminModal>
    );
  }
}
